



































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import HomeSlider from "../../store/entities/booking/homeSlider";
import SinglePicture from '../../components/single-picture.vue';
import Ajax from '../../lib/ajax';


@Component({
    components: { SinglePicture }
})
export default class CreateHomeSlider extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    homeSlider: HomeSlider = new HomeSlider();

    save() {
        (this.$refs.homeSliderForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "homeSlider/create",
                    data: this.homeSlider
                });
                (this.$refs.homeSliderForm as any).resetFields();

                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.homeSliderForm as any).resetFields();
        console.log(this.homeSlider)
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    async created(){

    }

    homeSliderRule = {
        imageUrl: [
            {
                required: true,
                message: this.L("UploadIsRequired", undefined, this.L("Picture")),
                trigger: "blur"
            }
        ],
        alt: [
            {
                type: 'string',
                max: 512,
                message: this.L("NoMoreThenLength", undefined, "Alt",'512'),
                trigger: "blur"
            }
        ],
        linkUrl: [
            {
                pattern: /^\d+$/,
                message: 'ID只能是数字',
                trigger: "blur"
            }
        ],
        displayOrder: [
            {
                type: 'integer',
                trigger: "blur"
            }
        ]
    };
}
